import { DiscountGroupDTO } from '../dto';

export class DiscountGroup {
  id: number;
  code: string;
  name: string;
  mgSupplierId?: number;
  count?: number;

  constructor({ id, name, code, mgSupplierId, count }: DiscountGroup) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.mgSupplierId = mgSupplierId;
    this.count = count;
  }

  static fromDto = (dto: DiscountGroupDTO): DiscountGroup =>
    new DiscountGroup({
      id: dto.id,
      code: dto.code,
      name: dto.name,
      mgSupplierId: dto.mgSupplierId,
      count: dto.count,
    });
}
